// extracted by mini-css-extract-plugin
export default {"Popup":"MapPopup_Popup__ClykW","TooltipTextItalic":"MapPopup_TooltipTextItalic__AnaG6"};